export default __webpack_public_path__ + "static/Tek_Rifle-c929cce66f27638747876d0a4e90c58a.png";